// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H0gqA{display:flex;flex-direction:column;gap:20px;align-items:flex-start}.AZ6Q9{margin:8px;width:70%;display:flex;align-items:center;gap:12px}.fWD3j{margin:8px}.mLAK4{display:flex;flex-direction:column;align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `H0gqA`,
	"copyApiKeyContainer": `AZ6Q9`,
	"goToContainer": `fWD3j`,
	"stepsContainer": `mLAK4`
};
export default ___CSS_LOADER_EXPORT___;
